

import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  Polyline,
} from 'react-google-maps';
import { makeStyles } from '@material-ui/core/styles';
import NewBookingDesign from './NewBookingDesign';
import LiveMapParent from './LiveMapParent';
import { useLocation } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import clsx from 'clsx';
import { useCompanyTheme } from '../../context/CompanyContext';

const useStyles = makeStyles((theme) => ({
  root: {},

  newBookDes: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "5%",
      width: "100%",
      height: "50%",
      position: "absolute",
    },
    [theme.breakpoints.up("lg")]: {
      top: "64px",
      bottom: "0",
      width: "50%",
      position: "fixed",
      left: "2%",
    },
  },

  googleMapDes: {
    [theme.breakpoints.down("sm")]: {
      padding: "5%",
    },
    [theme.breakpoints.up("lg")]: {
      top: "76px",
      bottom: "24px",
      width: "44%",
      position: "fixed",
      left: "53%",
      right: "1%",
    },
    overflowY: 'auto',
  },

  mapContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflowY: 'auto',
  },

  splitInfoOverlay: (props) => ({
    position: 'absolute',
    top: '20px',
    right: '20px',
    zIndex: 10,
    backgroundColor: props?.companyTheme?.primaryColorCode,
    padding: '8px 8px',
    borderRadius: '10px',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 'bold',
    width: '250px',
    maxHeight: '210px',
    overflowY: 'auto',
    overflowX: 'hidden',
    "&::-webkit-scrollbar": {
      display: "none",
    },
  }),

  skeletonItemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    maxHeight: '140px',
  },

  skeletonKey: {
    width: '50%',
    height: 18,
    marginRight: '10px',
    borderRadius: '2px',
    backgroundColor: '#808080',
    minWidth: '40px',
    padding: '5px'
  },

  skeletonValue: {
    width: '30%',
    height: 18,
    borderRadius: '2px',
    backgroundColor: '#808080',
    minWidth: '30px',
    padding: '5px'
  },

  skeletonLineSeparator: {
    height: '1px',
    backgroundColor: '#fff',
    margin: '18px 0',
  },

  skeletonFinalFare: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '12px',
    marginBottom: '8px',
  },

  highlightRow: (props) => ({
    width: '40%',
    height: 18,
    minWidth: '40px',
    borderBottom: '1px solid',
  }),

  highlightFare: (props) => ({
    width: '27%',
    height: 18,
    minWidth: '40px',
    borderBottom: '1px solid',
  }),
}));


function StopMarker({ markerDatas, icon, onMarkerClick }) {
  if (markerDatas != null) {
    let path = markerDatas.map((data) => {
      let ltlng = { lat: data.latitude, lng: data.longitude };
      return ltlng;
    });

    var res = [];
    for (var i = 0; i < path.length; i++) {
      res.push(
        <Marker
          icon={icon}
          key={i}
          position={path[i]}
          name={markerDatas[i].info}
          title={'sdfsdf'}
        />
      );
    }
    return res;
  } else {
    return <div></div>;
  }
}

function getloc(setCurrentLatLng) {
  navigator.geolocation.getCurrentPosition(function (position) {
    const currentLatLng = {
      lat: position.coords.latitude,
      lng: position.coords.longitude
    };
    setCurrentLatLng(currentLatLng);
  });
}

const SanMap = () => {
  const [currentLatLng, setCurrentLatLng] = useState({ lat: 0.0, lng: 0.0 });
  const [companyId, setCompanyId] = useState(null);

  const { companyTheme } = useCompanyTheme();

  // console.log("companyTheme", companyTheme);

  const classes = useStyles({ companyTheme });

  const location = useLocation();

  const mapRef = useRef(null);

  const detectedCompanyId = sessionStorage.getItem('companyId');

  useEffect(() => {
    if (detectedCompanyId) {
      setCompanyId(detectedCompanyId);
    }
  }, [detectedCompanyId]);

  // console.log("companyId", companyId);

  const params = new URLSearchParams(location.search);
  let pickupFromQuery = params.get('pickupplace');
  let dropFromQuery = params.get('dropplace');
  let pickupLatQuery = params.get('latitude');
  let pickupLngQuery = params.get('longitude');
  let dropLatQuery = params.get('drop_latitude');
  let dropLngQuery = params.get('drop_longitude');
  let type = params.get('type');

  const [fareBreakdownLoading, setFareBreakdownLoading] = useState(false);

  const [hourlyFareLoading, setHourlyFareLoading] = useState(false);

  const [planFareLoading, setPlanFareLoading] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('type', JSON.stringify(type));
    getloc(setCurrentLatLng);
  }, []);

  let initialCoords = new window.google.maps.LatLng(25.237078489210994, 55.447202757114084);

  const [pickUp, setPickup] = useState({
    isOpen: false,
    coords: initialCoords,
    address: ''
  });

  const [pickUp1, setPickup1] = useState({
    isOpen: false,
    coords: initialCoords,
    address: ''
  });
  const [waypoints, setWaypoints] = useState([]);


  const [drop, setDrop] = useState({
    isOpen: false,
    coords: new window.google.maps.LatLng(0.0, 0.0),
    address: ''
  });

  const [drop1, setDrop1] = useState({
    isOpen: false,
    coords: new window.google.maps.LatLng(0.0, 0.0),
    address: ''
  });

  const [estimatedTime, setEstimatedTime] = useState();
  const [driverMarkerData, setDriverMarkerData] = useState();
  const [tripID, setTripID] = useState('');
  const [showErrorMessage, setshowErrorMessage] = useState('');
  const [tripData, setTripData] = useState(null);
  const [MapLoader, setMapLoader] = useState(true);
  const [path, setPath] = useState([]);
  const [path1, setPath1] = useState([]);
  const [zoomCount, setZoomCount] = useState(12);
  const [loadData, setLoadData] = useState([]);

  const [allFareDetails, setAllFareDetails] = useState(null);
  const [allHourlyFareDetails, setAllHourlyFareDetails] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedModelFareBreakdown, setSelectedModelFareBreakdown] = useState(null);
  const [selectedModelHourlyFare, setSelectedModelHourlyFare] = useState(null);
  const [subscriptionFare, setSubscriptionFare] = useState([]);
  const [distance, setDistance] = useState(null);
  const [distance2, setDistance2] = useState(null);
  const [duration, setDuration] = useState(null);
  const [duration2, setDuration2] = useState(null);
  const [bookType, setBookType] = useState('');

  const [center, setCenter] = useState({ lat: 25.2048, lng: 55.2708 })


  const handleNewBookingData = useCallback((data) => {

    // console.log("data", data);

    // choose one of the two depending on your need
    // option 1: keep as object
    setAllFareDetails(() => ({ ...(data?.fareDetails || {}) }));

    // option 2: keep as array
    // setAllFareDetails(() => [data?.fareDetails || {}]);

    setSelectedModel(() => data?.selectedModel ? { ...data.selectedModel } : null);
    setBookType(data?.bookType);
    // setAllHourlyFareDetails(() => [...(data?.hourlyFareSplitup || [])]);
    setAllHourlyFareDetails(() => data?.hourlyFareSplitup || {});
    setSubscriptionFare(() => [...(data?.subscriptionFareSplitup || [])]);
    setFareBreakdownLoading(true);

   
    

  }, []);

    // console.log("zoomCount", zoomCount);


  // console.log("subscriptionFare", subscriptionFare);

  useEffect(() => {
    if (currentLatLng.lat !== 0 || pickupFromQuery) {
      if (pickupFromQuery && pickupLatQuery && pickupLngQuery) {
        setPickup({
          isOpen: false,
          coords: new window.google.maps.LatLng(parseFloat(pickupLatQuery), parseFloat(pickupLngQuery)),
          address: pickupFromQuery
        });
      } else if (currentLatLng.lat !== 0) {
        setPickup({
          isOpen: false,
          coords: new window.google.maps.LatLng(currentLatLng.lat, currentLatLng.lng),
          address: ''
        });
      }

      if (dropFromQuery && dropLatQuery && dropLngQuery) {
        setDrop({
          isOpen: false,
          coords: new window.google.maps.LatLng(parseFloat(dropLatQuery), parseFloat(dropLngQuery)),
          address: dropFromQuery
        });
      }
    }
  }, [currentLatLng, pickupFromQuery, pickupLatQuery, pickupLngQuery, dropFromQuery, dropLatQuery, dropLngQuery]);


  function getMidpoint(lat1, lng1, lat2, lng2) {
    const midLat = (lat1 + lat2) / 2;
    const midLng = (lng1 + lng2) / 2;
    return { lat: midLat, lng: midLng };
  }

  useEffect(() => {
    if (pickUp?.coords && drop?.coords && pickUp.coords.lat() !== 0 && drop.coords.lat() !== 0) {


      const center = getMidpoint(pickUp.coords.lat(), pickUp.coords.lng(), drop.coords.lat(), drop.coords.lng());
      setCenter(center);

      const directionsService = new window.google.maps.DirectionsService();

      // console.log("directionsService",directionsService);

      directionsService.route(
        {
          origin: pickUp.coords,
          destination: drop.coords,
          // waypoints: waypoints.map((wp) => ({
          //   location: new window.google.maps.LatLng(wp.coords.lat, wp.coords.lng),
          //   stopover: true,
          // })),
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            const routeLeg = result.routes[0].legs[0];
            const newPath = result.routes[0].overview_path.map((p) => ({
              lat: p.lat(),
              lng: p.lng(),
            }));


            // console.log("routeLeg",routeLeg);
            // console.log("newPath",newPath);
            setPath(newPath);

            const distanceValue = parseFloat(routeLeg.distance.text.replace(" km", ""));
            const durationText = routeLeg.duration.text;


            // console.log("distanceValue",distanceValue);
            // console.log("durationText",durationText);


            let totalMinutes = 0;
            const hoursMatch = durationText.match(/(\d+)\s*hour/);
            const minutesMatch = durationText.match(/(\d+)\s*min/);

            if (hoursMatch) {
              totalMinutes += parseInt(hoursMatch[1]) * 60;
            }
            if (minutesMatch) {
              totalMinutes += parseInt(minutesMatch[1]);
            } else if (durationText.includes('min') && !minutesMatch) {
              totalMinutes = parseInt(durationText.replace(' min', ''));
            }

            setDistance(distanceValue);
            setDuration(totalMinutes);

            // console.log("totalMinutes",totalMinutes);

            const arr = [
              { lat: pickUp.coords.lat(), lng: pickUp.coords.lng() },
              { lat: drop.coords.lat(), lng: drop.coords.lng() }
            ];
            setLoadData(arr);

          } else {
            console.error("❌ Directions request failed! Status:", status);
          }
        }
      );
    }
  }, [pickUp, drop]);


  useEffect(() => {
    if (pickUp1?.coords && drop1?.coords && pickUp1.coords.lat() !== 0 && drop1.coords.lat() !== 0) {

      const directionsService = new window.google.maps.DirectionsService();

      // console.log("directionsService",directionsService);

      directionsService.route(
        {
          origin: pickUp1.coords,
          destination: drop1.coords,
          // waypoints: waypoints.map((wp) => ({
          //   location: new window.google.maps.LatLng(wp.coords.lat, wp.coords.lng),
          //   stopover: true,
          // })),
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            const routeLeg = result.routes[0].legs[0];
            const newPath = result.routes[0].overview_path.map((p) => ({
              lat: p.lat(),
              lng: p.lng(),
            }));


            // console.log("routeLeg",routeLeg);
            // console.log("newPath",newPath);
            setPath1(newPath);

            const distanceValue = parseFloat(routeLeg.distance.text.replace(" km", ""));
            const durationText = routeLeg.duration.text;


            // console.log("distanceValue",distanceValue);
            // console.log("durationText",durationText);


            let totalMinutes = 0;
            const hoursMatch = durationText.match(/(\d+)\s*hour/);
            const minutesMatch = durationText.match(/(\d+)\s*min/);

            if (hoursMatch) {
              totalMinutes += parseInt(hoursMatch[1]) * 60;
            }
            if (minutesMatch) {
              totalMinutes += parseInt(minutesMatch[1]);
            } else if (durationText.includes('min') && !minutesMatch) {
              totalMinutes = parseInt(durationText.replace(' min', ''));
            }

            setDistance2(distanceValue);
            setDuration2(totalMinutes);


            // console.log("totalMinutes",totalMinutes);

            const arr = [
              { lat: pickUp1.coords.lat(), lng: pickUp1.coords.lng() },
              { lat: drop1.coords.lat(), lng: drop1.coords.lng() }
            ];
            setLoadData(arr);

          } else {
            console.error("❌ Directions request failed! Status:", status);
          }
        }
      );
    }
  }, [pickUp1, drop1]);


  useEffect(() => {

    //  console.log("selectedModel -------1",selectedModel);
    //   console.log("allFareDetails----------1",allFareDetails);

    if (selectedModel && allFareDetails) {

      // console.log("selectedModel -------2",selectedModel);
      // console.log("allFareDetails----------2",allFareDetails);

      if (allFareDetails) {
        setFareBreakdownLoading(false);
        setSelectedModelFareBreakdown(allFareDetails.split_up);

      } else {
        setSelectedModelFareBreakdown(null);
      }
    } else {
      setSelectedModelFareBreakdown(null);
    }
  }, [selectedModel, allFareDetails]);

  //  console.log("selectedModel",selectedModel);
  //     console.log("allFareDetails",allFareDetails);

  useEffect(() => {
    if (selectedModel && allHourlyFareDetails) {
      // const matchedFareDetail = allHourlyFareDetails.find(
      //   (fare) => fare._id === selectedModel.model_id
      // );

      // if (!matchedFareDetail) {
      //   setHourlyFareLoading(true);
      // }

      setHourlyFareLoading(true);

      if (allHourlyFareDetails && allHourlyFareDetails.split_up) {
        setSelectedModelHourlyFare(allHourlyFareDetails.split_up);
        setHourlyFareLoading(false);
      } else {
        setSelectedModelHourlyFare(null);
        setHourlyFareLoading(false);
      }
    } else {
      setSelectedModelFareBreakdown(null);
    }
  }, [selectedModel, allHourlyFareDetails]);

  useEffect(() => {
    if (pickUp.address === '' || drop.address === '') {
      setAllFareDetails(null);
      setAllHourlyFareDetails(null);
      setDistance(null);
      setDuration(null);
    }
  }, [pickUp, drop]);


  useEffect(() => {

    //  console.log("selectedModel -------1",selectedModel);

    if (subscriptionFare && subscriptionFare[0]?.value!== 0) {
      // console.log("selectedModel -------2",selectedModel);
      // console.log("allFareDetails----------2",allFareDetails);

      if (subscriptionFare && subscriptionFare !== null) {
        // console.log("allFareDetails----------2",allFareDetails);
        setPlanFareLoading(false);
      } else {
        setPlanFareLoading(true);
      }
    } 
  }, [subscriptionFare]);
  
  // console.log("bookType", bookType)

  function handleZoomChanged() {
    setZoomCount(this.getZoom());
  }


  const mapOptions = {
    zoom: zoomCount,
    minZoom: 2,
    maxZoom: 40,
    center,
    scaleControl: true,
    streetViewControl: false,
  };

  const icon = {
    url: 'https://booking.limor.us/static/images/top_view.png',
    scaledSize: new window.google.maps.Size(25, 50),
    anchor: { x: 75, y: 75 }
  };

  const pickupIcon = {
    url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
    size: new window.google.maps.Size(32, 32),
    anchor: new window.google.maps.Point(4, 4)
  };
  const pickupIcon2 = {
    url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
    size: new window.google.maps.Size(32, 32),
    anchor: new window.google.maps.Point(4, 4)
  };

  const SplitInfo = ({ fareBreakdown, isLoading }) => {
    // const classes = useStyles();

    // console.log("fareBreakdown",fareBreakdown);

    return (
      <div className={classes.splitInfoOverlay}>
        {fareBreakdown && Array.isArray(fareBreakdown) && fareBreakdown.length > 0 && !isLoading ? (
          fareBreakdown.map((set, setIndex) => (
            Array.isArray(set) && (
              <div
                key={setIndex}
                style={{
                  borderBottom: setIndex === fareBreakdown.length - 1 ? 'none' : '1px solid #ffff',
                  marginBottom: setIndex === fareBreakdown.length - 1 ? '0' : '10px',
                  paddingBottom: setIndex === fareBreakdown.length - 1 ? '0' : '5px',
                }}
              >
                {set.map((item) => (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '120px auto',
                      fontSize: '14px',
                      color: 'white',
                      marginBottom: '6px',
                    }}
                  >
                    <span style={{ textAlign: 'left', paddingRight: '8px' }}>
                      {item.formatted_key}
                    </span>
                    <span style={{ textAlign: 'left', paddingRight: '8px' }}>
                      :  {item.value}
                    </span>
                  </div>

                ))}
              </div>
            )
          ))
        ) : (
          <>
            <div className={classes.skeletonItemContainer}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
            <div className={classes.skeletonItemContainer}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
            <div className={classes.skeletonItemContainer}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
            {/* The horizontal separator line */}
            {/* <Skeleton variant="rectangular" className={classes.skeletonLineSeparator} /> */}
            <div className={classes.skeletonFinalFare}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
          </>
        )}
      </div>
    );
  };



  const HourlySplitInfo = ({ fareBreakdown, isLoading }) => {
    // const classes = useStyles();

    // console.log("fareBreakdown",fareBreakdown);

    return (
      <div className={classes.splitInfoOverlay}>
        {fareBreakdown && Array.isArray(fareBreakdown) && fareBreakdown.length > 0 && !isLoading ? (
          fareBreakdown.map((set, setIndex) => (
            Array.isArray(set) && (
              <div
                key={setIndex}
                style={{
                  borderBottom: setIndex === fareBreakdown.length - 1 ? 'none' : '1px solid #ffff',
                  marginBottom: setIndex === fareBreakdown.length - 1 ? '0' : '10px',
                  paddingBottom: setIndex === fareBreakdown.length - 1 ? '0' : '5px',
                }}
              >
                {set.map((item) => (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '120px auto',
                      fontSize: '14px',
                      color: 'white',
                      marginBottom: '6px',
                    }}
                  >
                    <span style={{ textAlign: 'left', paddingRight: '8px' }}>
                      {item.formatted_key}
                    </span>
                    <span style={{ textAlign: 'left', paddingRight: '8px' }}>
                      :  {item.value}
                    </span>
                  </div>

                ))}
              </div>
            )
          ))
        ) : (
          <>
            <div className={classes.skeletonItemContainer}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
            <div className={classes.skeletonItemContainer}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
            <div className={classes.skeletonItemContainer}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
            {/* The horizontal separator line */}
            {/* <Skeleton variant="rectangular" className={classes.skeletonLineSeparator} /> */}
            <div className={classes.skeletonFinalFare}>
              <Skeleton variant="rectangular" className={classes.skeletonKey} />
              <Skeleton variant="rectangular" className={classes.skeletonValue} />
            </div>
          </>
        )}
      </div>
    );
  };



  const SubscriptionInfo = ({ subscriptionFare, isLoading }) => {
    // const classes = useStyles();

    return (
      <div className={classes.splitInfoOverlay}>
        {subscriptionFare && Array.isArray(subscriptionFare) && subscriptionFare.length > 0 && !isLoading ? (
          subscriptionFare.map((set, setIndex) => (
            Array.isArray(set) && (
              <div
                key={setIndex}
                style={{
                  borderBottom: setIndex === subscriptionFare.length - 1 ? 'none' : '1px solid #ffff',
                  marginBottom: setIndex === subscriptionFare.length - 1 ? '0' : '10px',
                  paddingBottom: setIndex === subscriptionFare.length - 1 ? '0' : '5px',
                }}
              >
                {set.map((item, idx) => {
                  const isHighlighted = item.key === 'weekFare' && item.formatted_key === 'Fare Per Week';
                  const headingHighLight = item.key === 'baseFare' && item.formatted_key === 'Base Fare';

                  return (

                    <div
                      key={idx}
                      className={clsx({
                        [classes.highlightRow]: isHighlighted,
                        [classes.highlightFare]: headingHighLight,
                      })}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '120px auto',
                        fontSize: '14px',
                        marginBottom: '6px',
                      }}
                    >
                      <span style={{ textAlign: 'left', paddingRight: '8px' }}>
                        {item.formatted_key}
                      </span>
                      {
                        item.value ? (
                          <span style={{ textAlign: 'left', paddingRight: '8px' }}>
                            : {item.value}
                          </span>
                        ) : null
                      }
                    </div>

                  );
                })}
              </div>
            )
          ))
        ) : (
          <>
            {[...Array(3)].map((_, i) => (
              <div key={i} className={classes.skeletonItemContainer}>
                <Skeleton variant="rectangular" className={classes.skeletonKey} />
                <Skeleton variant="rectangular" className={classes.skeletonValue} />
              </div>
            ))}
          </>
        )}
      </div>
    );
  };



  const onLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const onUnmount = useCallback(function callback(map) {
    mapRef.current = null;
  }, []);

  useEffect(() => {
    if (mapRef.current && path.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();

      path.forEach(coord => {
        bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
      });


      mapRef.current.fitBounds(bounds, {
        top: 50,
        bottom: 50,
        left: 10,
        right: 350,
      });

      // setTimeout(() => {
      //   const currentZoom = mapRef.current.getZoom();
      //   console.log("Current Zoom:", currentZoom);

      //   // Optional: Force a min or max zoom level
      //   if (currentZoom < 10) {
      //     mapRef.current.setZoom(10);
      //   }
      // }, 500);
    }
  }, [path]);

  const hasZeroInSplitUp = (fareBreakdown) => {
    if (!Array.isArray(fareBreakdown)) return true;

    for (const set of fareBreakdown) {
      if (!Array.isArray(set)) continue;

      for (const item of set) {
        const key = item?.key?.toLowerCase?.() || '';
        const val = String(item?.value || '').trim().toLowerCase();

        // Specifically check for Duration and Distance Fare being 0
        if (
          (key === 'duration' && (val === '0 hrs' || val.startsWith('0'))) ||
          (key === 'distancefare' && (val === 'aed 0' || val === 'aed 0.00' || val.startsWith('aed 0')))
        ) {
          return true;
        }
      }
    }

    return false;
  };



  // console.log("waypoints",waypoints);


  const GoogleMapExample = withGoogleMap((props) => (
    <GoogleMap
      // ref={(map) => {
      //   const bounds = new window.google.maps.LatLngBounds();
      //   loadData.map((x) => {
      //     bounds.extend(new window.google.maps.LatLng(x.lat, x.lng));
      //   });

      //   // console.log("bounds", bounds);

      //   if (loadData.length > 1) {

      //     // console.log("loadData", loadData);
      //     map && map.fitBounds(bounds, { left: 100, right: 100, top: 10 }) && map.setZoom(16);
      //     // mapRef.current.fitBounds(bounds);
      //     // if (mapRef.current.getZoom() > 16) {
      //     //   mapRef.current.setZoom(16);
      //     // }
      //   }

      // }}

      mapContainerStyle={{ width: '100%', height: '100%' }}
      onZoomChanged={handleZoomChanged}
      defaultCenter={center}
      onLoad={onLoad}
      onUnmount={onUnmount}
      // defaultZoom={zoomCount}
      // options={{
      //   styles: greyMapStyle,
      // }}
      options={mapOptions}

    >
      {path.length > 0 && pickUp?.coords && pickUp?.address && drop?.coords && drop?.address && (
        <Polyline path={path}
          options={{
            strokeColor: '#000000',
            strokeOpacity: 0.9,
            strokeWeight: 4,
            zIndex: 1
          }} />

      )}

      {pickUp?.coords && pickUp?.address && (
        <Marker position={pickUp.coords} icon={pickupIcon2} />
      )}

      {drop?.coords && drop?.address && (
        <Marker position={drop.coords} icon={pickupIcon} />
      )}

      <StopMarker markerDatas={driverMarkerData} icon={icon} />

    </GoogleMap>
  ));




  const MemoizedMap = useMemo(() => {
    return (
      <GoogleMapExample
        containerElement={<div style={{ height: '100%', width: '100%' }} />}
        mapElement={<div style={{ height: `100%`, width: '100%' }} />}
      />
    );
  }, [pickUp, drop, path, driverMarkerData]);





  // console.log("selectedModelFareBreakdown", selectedModelFareBreakdown);


  return (
    <div>
      <div className={classes.googleMapDes}>
        <NewBookingDesign
          pickup={pickUp}
          setPickup={setPickup}
          drop={drop}
          setDrop={setDrop}
          waypoints={waypoints}
          setWaypoints={setWaypoints}
          setDriverMarkerData={setDriverMarkerData}
          path={path}
          setPath={setPath}
          tripID={tripID}
          setTripID={setTripID}
          showErrorMessage={showErrorMessage}
          setshowErrorMessage={setshowErrorMessage}
          tripData={tripData}
          setTripData={setTripData}
          estimatedTime={estimatedTime}
          dateProps={params.get('pickup_time')}
          timeProps={params.get('time')}
          hourlyHire={params.get('hourlyHire')}
          distance={distance}
          duration={duration}
          pickup1={pickUp1}
          setPickup1={setPickup1}
          drop1={drop1}
          setDrop1={setDrop1}
          onBookingDataChange={handleNewBookingData}
          path1={path1}
          setPath1={setPath1}
          duration2={duration2}
          distance2={distance2}
          companyId={companyId}
        />
      </div>

      <div className={classes.newBookDes}>
        {tripID === '' ? (
          <div className={classes.mapContainer}>
            {MemoizedMap}
            {(bookType === 0 && pickUp.address !== '' && drop.address !== '') && (
              <SplitInfo
                fareBreakdown={selectedModelFareBreakdown}
                // isLoading={fareBreakdownLoading || (selectedModelFareBreakdown === null && allFareDetails === null && pickUp.address && drop.address)}
                isLoading={fareBreakdownLoading || (!selectedModelFareBreakdown && allFareDetails === null && pickUp.address && drop.address)}
              />
            )}
            {(bookType === 4 && pickUp.address !== '' && drop.address !== '' && selectedModelHourlyFare && !hasZeroInSplitUp(selectedModelHourlyFare) && selectedModelHourlyFare.length !== 0) && (
              <HourlySplitInfo
                fareBreakdown={selectedModelHourlyFare}
                isLoading={hourlyFareLoading || (!selectedModelHourlyFare && allHourlyFareDetails === null && pickUp.address && drop.address)}
              />
            )}
            {bookType === 3 && pickUp.address !== '' && drop.address !== '' && subscriptionFare.length > 0 &&(
              <SubscriptionInfo
                subscriptionFare={subscriptionFare}
                // isLoading={planFareLoading || (  !subscriptionFare && pickUp.address && drop.address)}
              />
            )}

          </div>
        ) : (
          <LiveMapParent
            tripID={tripID}
            setTripID={setTripID}
            setEstimatedTime={setEstimatedTime}
            showErrorMessage={showErrorMessage}
            setshowErrorMessage={setshowErrorMessage}
            tripData={tripData}
            setTripData={setTripData}
          />
        )}
      </div>
    </div>
  );
};

export default SanMap;